import notFoundJson from "@/lib/prismicio/prismic-not-found.json"
import { PrismicNotFoundJson } from "@jog/shared"
import { useMemo } from "react"

export const useNotFound = () => useMemo(() => notFoundJson as PrismicNotFoundJson, [])
